import { DownOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, DatePicker, Input, Pagination, PaginationProps, Select, TreeSelect, Typography } from 'antd';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';
import '../../../../style.scss';
import { dataPagination, formatPrice } from '../../../../../../../until';
import { IDetailGroup } from '../../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { ISelectOption } from '../../../../../../../api/selectOption/selectOptionsApi';
import { getListUserAccount, IAccount } from '../../../../../../../api/groupPermission/groupPermissionApi';
import { NodataTable } from '../../../../../../../components/NoDataTable';
import useLoading from '../../../../../../../hook/useLoading';
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../../../../../store/slices/infoUserSlice';
import useDebounce from '../../../../../../../hook/useDebounce';
import { columnDefs, ISelectedUserAccount, PERMISSION } from '../../../AddGroup/Component/AG_Decentralization';
import { useCustomerGroupContext } from '../../../../indexV2';
import { formatNumber } from '../../../../../../../services/mixin';



interface IDataDefaulFilterList {
    search?: string;
    listUnit?: number[]
}

const dataDefaulFilterList: IDataDefaulFilterList = {
    listUnit: [],
};

interface Props {

    inforGroup?: IDetailGroup

    setSelectedIdAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>
}
const EG_Decentralization: React.FC<Props> = ({
    inforGroup,
    setSelectedIdAccount
}) => {

    const pushLoading = useLoading()
    const { groupPermission } = useSelector(selectorInfoUser)
    const {
        //  sLUnit
        sLNationwide

    } = useCustomerGroupContext();
    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);
    const columnDefsMemo = useMemo<ColDef[]>(() => columnDefs, []);
    const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());
    const [permissionByUserId, setPermissionByUserId] = useState<
        Record<string, PERMISSION>
    >({});
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [tabPermission, setTabPermission] = useState(PERMISSION.VIEW)

    const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)


    const [listUserAccount, setListUserAccount] = useState<IAccount[]>([]);
    const selectedIdsRef = useRef<Set<string>>(new Set());
    const permissionByUserIdRef = useRef<Record<string, PERMISSION>>({});

    useEffect(() => {
        selectedIdsRef.current = selectedIds;
    }, [selectedIds]);

    useEffect(() => {
        permissionByUserIdRef.current = permissionByUserId;
    }, [permissionByUserId]);

    const permissionLabelMap: Record<PERMISSION, string> = {
        [PERMISSION.VIEW]: "Xem",
        [PERMISSION.EDIT]: "Sửa",
        [PERMISSION.DELETE]: "Sửa, Xóa",
    };

    const defaultColDef = useMemo<ColDef>(
        () => ({
            resizable: true,
            flex: 1,
            valueFormatter: (params: any) =>
                params.value && String(params.value).trim() !== ""
                    ? params.value
                    : "Không xác định",
        }),
        []
    );
    useEffect(() => {
        const listAdmin = inforGroup?.listAdmin ?? [];

        const nextSelectedIds = new Set<string>();
        const nextPermissionByUserId: Record<string, PERMISSION> = {};

        listAdmin.forEach((item) => {
            const adminId = String(item.adminId);

            nextSelectedIds.add(adminId);
            nextPermissionByUserId[adminId] = item.permissionType as PERMISSION;
        });

        selectedIdsRef.current = nextSelectedIds;
        permissionByUserIdRef.current = nextPermissionByUserId;

        setSelectedIds(nextSelectedIds);
        setPermissionByUserId(nextPermissionByUserId);

        setSelectedIdAccount(listAdmin);
        setDataFilterList(dataDefaulFilterList);
    }, [inforGroup, setSelectedIdAccount]);

    const gListUserAccount = useDebounce(async (limit: number = 10, pageNumber: number = 1) => {
        pushLoading(true)
        // if (inforGroup?.id) return
        const { listUnit, search } = dataFilterList

        const result = await getListUserAccount(
            limit, pageNumber, listUnit, undefined,
            search, groupPermission ?? undefined, 1, inforGroup?.id,
            1
        );
        if (result.status) {
            setListUserAccount(result.data)
            setPagination({ current: pageNumber, total: result.total, pageSize: limit });

        } else {
            // pushToast(result.message, "error", 2000);
        }
        pushLoading(false)
    }, 1000)

    const rowData = useMemo(() => {
        return (listUserAccount ?? []).map((item: any) => {
            const userId = String(item.id);
            const permissionType = permissionByUserId[userId];

            return {
                ...item,
                permission:
                    permissionType !== undefined
                        ? permissionLabelMap[permissionType]
                        : undefined,
            };
        });
    }, [listUserAccount, permissionByUserId]);

    const restoreSelection = useCallback(() => {
        const api = gridApiRef.current;
        if (!api) return;

        isRestoringSelection.current = true;

        api.forEachNode((node) => {
            const id = node.data?.id;

            if (id === undefined || id === null) return;

            const isSelected = selectedIdsRef.current.has(String(id));

            node.setSelected(isSelected, false);
        });

        setTimeout(() => {
            isRestoringSelection.current = false;
        }, 0);
    }, []);

    // useEffect(() => {
    //     restoreSelection();
    // }, [rowData, selectedIds, restoreSelection]);

    const onFirstDataRendered = useCallback(() => {
        restoreSelection();
    }, [restoreSelection]);

    const onRowDataUpdated = useCallback(() => {
        restoreSelection();
    }, [restoreSelection]);

    //------------------------------------
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    const onGridReady = useCallback(
        (params: { api: GridApi }) => {
            gridApiRef.current = params.api;

            setTimeout(() => {
                restoreSelection();
            }, 0);
        },
        [restoreSelection]
    );

    const onSelectionChanged = useCallback(
        (event: SelectionChangedEvent) => {
            if (isRestoringSelection.current) return;

            const api = event.api;

            const selectedIdsOnPage = new Set(
                api
                    .getSelectedNodes()
                    .filter((node) => node.data?.id !== undefined && node.data?.id !== null)
                    .map((node) => String(node.data.id))
            );

            const currentPageIds = new Set(
                (listUserAccount ?? []).map((row: any) => String(row.id))
            );

            const prevSelectedIds = selectedIdsRef.current;
            const nextSelectedIds = new Set(prevSelectedIds);

            const added: string[] = [];
            const removed: string[] = [];

            currentPageIds.forEach((id) => {
                const isSelectedNow = selectedIdsOnPage.has(id);
                const wasSelectedBefore = prevSelectedIds.has(id);

                if (isSelectedNow && !wasSelectedBefore) {
                    added.push(id);
                    nextSelectedIds.add(id);
                }

                if (!isSelectedNow && wasSelectedBefore) {
                    removed.push(id);
                    nextSelectedIds.delete(id);
                }
            });

            if (!added.length && !removed.length) return;

            const nextPermissionByUserId = {
                ...permissionByUserIdRef.current,
            };

            added.forEach((id) => {
                nextPermissionByUserId[id] = tabPermission;
            });

            removed.forEach((id) => {
                delete nextPermissionByUserId[id];
            });

            selectedIdsRef.current = nextSelectedIds;
            permissionByUserIdRef.current = nextPermissionByUserId;

            setSelectedIds(nextSelectedIds);
            setPermissionByUserId(nextPermissionByUserId);

            setSelectedIdAccount((prevList) => {
                const removedSet = new Set(removed);

                const keptList = prevList.filter(
                    (item) => !removedSet.has(String(item.adminId))
                );

                const addList = added.map((id) => ({
                    adminId: Number(id),
                    permissionType: tabPermission,
                }));

                const map = new Map<number, ISelectedUserAccount>();

                keptList.forEach((item) => {
                    map.set(Number(item.adminId), item);
                });

                addList.forEach((item) => {
                    map.set(Number(item.adminId), item);
                });

                return Array.from(map.values());
            });
        },
        [listUserAccount, tabPermission, setSelectedIdAccount]
    );
    //------------------------------------

    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedUserAccount = (itemsAdd: string[], itemsRemove: string[]) => {
        setSelectedIdAccount((prevList) => {
            // Nếu có add
            if (itemsAdd.length > 0) {
                const newUsers = itemsAdd.map((id) => ({
                    adminId: Number(id),
                    permissionType: tabPermission,
                }));
                return [...prevList, ...newUsers];
            }

            // Nếu có remove
            if (itemsRemove.length > 0) {
                return prevList.filter((user) => !itemsRemove.includes(user.adminId.toString()));
            }
            return prevList;
        });
    };


    // --- Khi đổi page ---
    const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
        gListUserAccount(pageSize, pageNumber);
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && listUserAccount && listUserAccount.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIds.has(node.data.id)) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [listUserAccount, selectedIds]);

    useEffect(() => {
        if (inforGroup) {
            // const adminIds = new Set(
            //     inforGroup.listAdmin
            //         // .filter(item => item.permissionType === PERMISSION.EDIT)
            //         .map(item => item.adminId.toString())
            // );

            // setSelectedIds(adminIds);
            setDataFilterList(dataDefaulFilterList)
            setSelectedIdAccount(inforGroup.listAdmin)
        } else {
            setDataFilterList(dataDefaulFilterList)
            // setSelectedIds(new Set())
            setSelectedIdAccount([])
        }

    }, [inforGroup]);

    useEffect(() => {
        gListUserAccount()
    }, [dataFilterList, inforGroup])


    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white rounded">
            {/* Filters */}
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">

                            <TreeSelect

                                className="w-full text-left text-span-select custom-input-focus text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterList?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterList({ ...dataFilterList, listUnit: e })}
                            />
                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm tài khoản người dùng"

                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterList.search}
                        onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
                    />
                    <div className=" border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>
            </div>
            <div className="custom-page-css flex items-center justify-between gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className='custom-page-css text-base text-4B4B4B font-regular'>Đã chọn:</span>
                    <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(selectedIds.size)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div className={`${tabPermission === PERMISSION.VIEW ? 'border-40A9FF bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.VIEW)}
                    >
                        <span className={`${tabPermission === PERMISSION.VIEW ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Xem</span>
                    </div>
                    <div className="custom-page-css divider"></div>
                    <div className={`${tabPermission === PERMISSION.EDIT ? 'border bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.EDIT)}
                    >
                        <span className={`${tabPermission === PERMISSION.EDIT ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Sửa</span>
                    </div>
                    <div className="custom-page-css divider"></div>
                    <div className={`${tabPermission === PERMISSION.DELETE ? 'border bg-E6F7FF' : 'border'} custom-page-css flex items-center justify-center py-1 px-3  rounded-3xl  cursor-pointer`}
                        onClick={() => setTabPermission(PERMISSION.DELETE)}
                    >
                        <span className={`${tabPermission === PERMISSION.DELETE ? 'text-40A9FF' : 'text-98A2B3 '} custom-page-css text-base font-regular`}>Sửa, Xóa</span>
                    </div>
                </div>
            </div>
            <div className="ag-theme-alpine custom-table-ag">
                <AgGridReact
                    domLayout="autoHeight"
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    rowData={rowData}

                    columnDefs={columnDefsMemo}
                    rowHeight={55}
                    defaultColDef={defaultColDef}
                    overlayNoRowsTemplate={NodataTable}
                    rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                    getRowId={getRowId}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onFirstDataRendered={onFirstDataRendered}
                    onRowDataUpdated={onRowDataUpdated}
                    maintainColumnOrder
                />
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={pagination.current}
                        pageSize={pagination.pageSize}
                        total={pagination.total}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
                        className='rs-pagination'
                        onChange={onPaginationChange}
                    />
                </div>
            </ConfigProvider>
        </div>
    )
}
export default React.memo(EG_Decentralization)
